module.exports = __webpack_public_path__ + "media/images/icon-website-eae44365981208f0b5306e58d5f90dda.svg";